"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("helpers/errors");
const constants_1 = require("modules/content/constants");
class ComplementaryReadingValidation {
    constructor(t) {
        this.t = t;
    }
    validateArticleUrl(value) {
        const errors = [];
        if (value.length > constants_1.READING_URL_MAX_CHARACTERS) {
            errors.push(this.t('validations.maxLength', {
                data: { maxLength: constants_1.READING_URL_MAX_CHARACTERS }
            }));
        }
        return errors;
    }
    validateArticleName(value) {
        const errors = [];
        if (value.length > constants_1.READING_ARTICLE_NAME_MAX_CHARACTERS) {
            errors.push(this.t('validations.maxLength', {
                data: { maxLength: constants_1.READING_ARTICLE_NAME_MAX_CHARACTERS }
            }));
        }
        return errors;
    }
    validateSiteName(value) {
        const errors = [];
        if (value.length > constants_1.READING_SITE_NAME_MAX_CHARACTERS) {
            errors.push(this.t('validations.maxLength', {
                data: { maxLength: constants_1.READING_SITE_NAME_MAX_CHARACTERS }
            }));
        }
        return errors;
    }
    hasError(errors) {
        return Object.values(errors).some((value) => value.length > 0);
    }
    async validate(values) {
        const errors = {
            articleUrl: this.validateArticleUrl(values.articleUrl),
            articleName: this.validateArticleName(values.articleName),
            siteName: this.validateSiteName(values.siteName)
        };
        if (this.hasError(errors)) {
            throw new errors_1.ValidationError(errors);
        }
        return values;
    }
}
exports.default = ComplementaryReadingValidation;
